import * as Sentry from '@sentry/vue';
import CONFIG from '@/config';

import { SentryReportError } from './error';

/**
 * 统一的 Sentry 上报函数
 * @param params 上报参数
 * @param params.name 事件名称（必填）
 * @param params.level 错误级别，默认为 error
 * @param params.context 额外上下文信息（可选）
 * @param params.error 错误对象（可选）
 */
export function sentryReport(params) {
    const { name, level = 'error', context, error } = params;

    try {
        // 在开发环境仍然打印到控制台便于调试
        if (CONFIG.ENV !== 'pre' && CONFIG.ENV !== 'production') {
            console.error(`[${level.toUpperCase()}] ${name}:`, error, context);
        }

        // 设置额外的上下文信息
        Sentry.withScope((scope) => {
            scope.setLevel(level);
            scope.setTag('ErrorSource', 'Manual');
            scope.setTag('EventName', name);

            if (context) {
                scope.setContext('reportContext', context);
            }

            if (error instanceof Error) {
                const sentryError = new SentryReportError(name, error);

                // 设置标签和额外信息
                scope.setTag('ErrorType', error.name);
                scope.setExtra('originalErrorMessage', error.message);
                scope.setExtra('originalErrorName', error.name);
                scope.setExtra('customEventName', name);

                // 使用 captureException 保留所有 Sentry 异常处理能力
                Sentry.captureException(sentryError);
            } else if (error) {
                // 非 Error 对象，使用 captureMessage 并保存错误数据
                Sentry.captureMessage(name, {
                    extra: { errorData: error },
                });
            } else {
                // 只有事件名称的情况
                Sentry.captureMessage(name);
            }
        });
    } catch (sentryError) {
    // Sentry 上报失败时回退到 console，避免循环
        console.error('Sentry上报失败:', sentryError, '原始事件:', name, error);
    }
}
